<template>
  <div class="examChapter">
    <common-breadcrumb/>
    <div class="main-container">
      <div class="chapter-selected clearfix">
        <div class="first-step" v-if="isShow">
          <div class="content-title">
            <span class="step">第一步</span>
            <span class="tip">请选择要练习的章节</span>
          </div>
          <div class="content-list">
            <el-radio-group v-model="selectValue">
              <el-radio
                v-for="(item, idx) in chapterList"
                :key="idx"
                :label="item.chapterName"
                :disabled="item.chapterID === 0"
                @change="nextStep(idx, item.chapterID, item.chapterListID)"/>
            </el-radio-group>
          </div>
        </div>
        <div class="second-step" v-else>
          <div class="content-title">
            <span class="step">第二步</span>
            <span class="tip">请设置本章练习中心的题型及题量</span>
          </div>
          <div class="content-type-second fl">
            <div class="item">
              <span>练习名称：</span>
              <input type="text" v-model="exerciseName">
              <em v-if="checkMsName">请输入试卷名称</em>
            </div>
            <div class="item">
              <span>做题时间：</span>
              <input type="text" :style="{width: '40px'}" v-model="exerciseTime"> 分钟
              <em v-if="checkMsTime === 1">请输入正整数</em>
              <em v-else-if="checkMsTime === 2">做题时间最大值为600</em>
            </div>
            <div class="item-checkbox">
              <div class="fl quest-type">题目类型：</div>
              <div class="fl type-item">
                <div v-for="(item,idx) in exerciseTypeArr" :key="idx">
                  <el-checkbox :label="item.viewTypeName + '（共' + item.total + '题）'"
                               name="type"
                               :checked="item.checked"
                               @change="selectType(idx)"
                               :disabled="false"/>
                  <input type="text"
                         v-model="exerciseTypeArr[idx].randomNum"
                         :disabled="!item.checked"
                         @input="changePerQuesNum($event, idx)"
                         @blur="checkIsSpace">题
                  <!-- <em v-if="checkPerQuesCount(exerciseTypeArr[idx].randomNum)">请输入非负数字</em> -->
                </div>
              </div>
            </div>
          </div>
          <div class="content-type-submit fl">
            <el-button type="primary" round :disabled="buttonDisable" @click="startExercise()">开始练习</el-button>
            <em v-if="typeNum">题目输入数量不能大于题目可选数量，请重新输入！</em>
            <em v-else-if="typeSpace">所有选择题目类型的题目输入数量不能为空！</em>
            <em v-else-if="isDecimal">所有选择题目类型的题目输入数量不能为小数或其他字符！</em>
            <em v-else-if="checkQuseCount">题目总数可选范围为1至60。</em>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { CommonBreadcrumb } from '@components/common/'
  import { getChapterList, getQuestionType, checkTempPaper } from '@api'
  import { timestampToTime, LoadingOptions, setCookie, getCookie, parseNumber } from "@/utils"


  export default {
    name: 'examChapter',
    components: {
      CommonBreadcrumb
    },
    data() {
      return {
        selectValue: '',
        chapterList: [],          // 章节数据
        exerciseName: '',         // 自定义练习名称
        exerciseTime: '60',       // 自定义练习时间限制
        quesCount: 0,             // 题目总数
        exerciseTypeArr: [],      // 自定义练习题型数据
        chapterID: 0,
        strategy: [],             // 组卷策略
        msName: false,
        msTime: false,
        typeNum: false,
        typeSpace: false,
        isShow: true,
        courseID: '',                     //
        siteCourseID: '',                 //
        courseName: 'mid',                 //
        flag: '',                          //
        loadingInstance: null,
        majorID: '',//辅导ID
        isDecimal: false,
        tempArr: []   //题型选中的临时数组
      }
    },
    watch:{
      '$route':function(to,from){
        if(to.query.time !== from.query.time){
          this.isShow = true
        }
      }
    },
    mounted() {
      this.initData()
      this.getChapterListFun()
    },
    computed: {
      //  验证练习名称
      checkMsName() {
        return this.exerciseName === ''
      },
      //  验证做题时间
      checkMsTime() {
        let reg = /^\d+$/
        if (!(reg.test(this.exerciseTime) && parseInt(this.exerciseTime) !== 0)) {
          return 1
        } else if (Number(this.exerciseTime) > 600) {
          return 2
        } else {
          return 0
        }
      },

      //  验证题目总数
      checkQuseCount() {
        let count = this.quesCount
        let isChecked = this.exerciseTypeArr.some(item => item.checked)
        return isChecked && (count > 60 || count <= 0)
      },
      buttonDisable() {
        let result =
            !this.typeNum &&
            !this.typeSpace &&
            !this.isDecimal &&
            !this.msName &&
            !this.msTime &&
            this.quesCount <= 60 &&
            this.quesCount > 0 &&
            this.exerciseTime !== '' &&
            Number(this.exerciseTime) <= 600 &&
            Number(this.exerciseTime) > 0 &&
            this.checkMsTime !== 1 &&
            this.checkMsTime !== 2 &&
            !this.checkMsName
        return !result
      }
    },
    methods: {
      // 初始化数据
      initData() {
        const { siteCourseID, courseID } = this.$route.query
        const { flag } = this.$route.params
        this.flag = flag === 'paidExam' ? '' : flag
        this.courseID = Number(courseID)
        this.siteCourseID = Number(siteCourseID)
        const { majorID } = this.$categoryInfo
        this.majorID = majorID
      },
      // 获取章节练习列表
      getChapterListFun() {
        let params = {
          flag: this.flag,
          siteCourseID: this.siteCourseID,
        }
        this.loadingInstance = this.$loading(LoadingOptions)
        getChapterList(params).then(res => {
          this.$nextTick(() => {
            this.loadingInstance.close()
          })
          this.chapterList = res
        })
      },
      // 下一步
      async nextStep(index, chapterID, chapterListID) {
        this.selectValue = index
        this.exerciseName = this.chapterList[index].chapterName + ' ' + timestampToTime()
        this.chapterID = Number(chapterID)

        let params = {
          flag: this.flag,
          chapterID: this.chapterID,
          chapterListID
        }
        this.getQuestionTypeFun(params)

      },
      // 获取章节练习题题型参数
      getQuestionTypeFun(params) {
        // this.loadingInstance = this.$loading(LoadingOptions)
        getQuestionType(params).then(async res => {
          this.$nextTick(() => {
            this.loadingInstance.close()
          })
          this.exerciseTypeArr = res
          for (let item of this.exerciseTypeArr) {
            Object.assign(item, {
              checked: false,
              randomNum: ''
            })
          }

          this.isShow = false
        })
      },
      // 选择题型
      selectType(idx) {
        this.exerciseTypeArr[idx].checked = !this.exerciseTypeArr[idx].checked
        if (!this.exerciseTypeArr[idx].checked) {
          this.exerciseTypeArr[idx].randomNum = ''
          this.typeSpace = false
          this.isDecimal = false
        } else {
          this.typeSpace = true
        }
        this.checkIsChecked()
        this.checkIsSpace()
        if (this.typeSpace) return
        this.$forceUpdate()
      },
      // 每个题型数量更改
      changePerQuesNum(e, idx) {
        this.checkIsNum(e)
        if (parseInt(e.target.value) > this.exerciseTypeArr[idx].total) {
          this.exerciseTypeArr[idx].randomNum = ''
          this.typeNum = true
        } else {
          this.typeNum = false
          this.typeSpace = false
          this.quesCount = 0
          this.exerciseTypeArr.forEach((val, index) => {
            if (val.randomNum !== '' && idx !== index) {
              this.quesCount += parseInt(val.randomNum)
            } else if (val.randomNum !== '' && idx === index) {
              this.quesCount += parseInt(e.target.value)
            }
          })
        }
        this.checkIsSpace()
      },
      //验证是否为空
      checkIsSpace() {
        let isSpace = this.exerciseTypeArr.some(item => {
          return item.checked && item.randomNum === ''
        })
        if (isSpace) {
          this.typeSpace = true
          this.typeNum = false
          this.isDecimal = false
        }else{
          this.checkIsNum()
        }
      },
      //验证是否都没选中
      checkIsChecked() {
        this.tempArrFun()
        let isNoChecked = this.tempArr.every(item => {
          return !item.checked
        })
        if (isNoChecked) {
          this.quesCount = 0
          this.isDecimal = false
          this.typeSpace = false
          this.typeNum = false
        } else {
          this.checkIsNum()
        }
      },
      //验证是否为数字
      checkIsNum(e) {
        if (e) {
          if (e.target.value !== '' && !/^\d+$/.test(e.target.value)) {
            this.isDecimal = true
            this.typeSpace = false
            this.typeNum = false
            return
          } else {
            this.isDecimal = false
          }
        } else {
          let isNotNum = this.tempArr.some(item => {
            return !/^\d+$/.test(item.randomNum)
          })
          if (isNotNum) {
            this.isDecimal = true
            this.typeSpace = false
            this.typeNum = false
          }
        }
      },
      //选中的临时数组
      tempArrFun() {
        this.tempArr = []
        this.exerciseTypeArr.forEach((v, k) => {
          if (v.checked === true) {
            this.tempArr.push(v)
          }
        })
      },
      // 开始练习
      startExercise() {
        let strategy = []
        this.isShow = true
        this.exerciseTypeArr.forEach(val => {
          if (val.checked === true) {
            strategy.push({
              quesViewTypeID: parseInt(val.quesViewTypeID),
              randomNum: parseInt(val.randomNum)
            })
          }
        })
        setCookie('strategy', JSON.stringify(strategy))
        setCookie('exerciseName', this.exerciseName)
        setCookie('exerciseTime', Number(this.exerciseTime) > 600 ? 600 : this.exerciseTime)

        let uid = getCookie('cdeluid') || ''
        this.$router.push({
            name: 'doExamChapter',
            query: {
              siteCourseID: this.siteCourseID,
              courseID: this.courseID,
              chapterID: Number(this.chapterID),
              temp: '1'
            }
          })
        // let params = {
        //   siteCourseID: this.siteCourseID,
        //   flag: this.flag,
        //   userID: parseNumber(uid),
        //   chapterID: this.chapterID
        // }
        // // 查询是否有临时保存试题
        // checkTempPaper(params).then(res => {
        //   if (res.length > 0) {
        //     const tempData = res[0]
        //     let _confirm = confirm('请确认 ：是否继续上次未完成的试卷?\n按“确定”将打开上次的试卷\n按“取消”则打开新试卷')
        //     if (_confirm) {
        //       return this.$router.push({
        //         name: 'doExamChapter',
        //         query: {
        //           siteCourseID: this.siteCourseID,
        //           courseID: this.courseID,
        //           bizID: String(tempData.bizID),
        //           spendTime: String(tempData.spendTime),
        //           chapterID: Number(this.chapterID),
        //           temp: '2'
        //         }
        //       })
        //     } else {
        //       return this.$router.push({
        //         name: 'doExamChapter',
        //         query: {
        //           siteCourseID: this.siteCourseID,
        //           courseID: this.courseID,
        //           // bizID: String(tempData.bizID),
        //           spendTime: 0,
        //           chapterID: this.chapterID,
        //           temp: '1',
        //           includeTempButAbandon: '1'
        //         }
        //       })
        //     }
        //   }
        //   return this.$router.push({
        //     name: 'doExamChapter',
        //     query: {
        //       siteCourseID: this.siteCourseID,
        //       courseID: this.courseID,
        //       chapterID: Number(this.chapterID),
        //       temp: '1'
        //     }
        //   })
        // })
      }
    }
  }
</script>
